import { usePathname } from "next/navigation";
import { useEffect, useMemo } from "react";

import useBreadcrumbsStore from "./Breadcrumbs.store";

export function useBreadcrumbsPath() {
  const pathname = usePathname();
  const currentPath = useBreadcrumbsStore((state) => state.currentPath);
  const setCurrentPath = useBreadcrumbsStore((state) => state.setCurrentPath);
  const prevPath = useBreadcrumbsStore((state) => state.prevPath);
  const setPrevPath = useBreadcrumbsStore((state) => state.setPrevPath);

  useEffect(() => {
    setCurrentPath(pathname);

    if (pathname !== currentPath) {
      setPrevPath(currentPath);
    }
  }, [pathname, currentPath, setCurrentPath, setPrevPath]);

  const hasPreviousPath = useMemo(() => {
    return prevPath && prevPath !== pathname;
  }, [prevPath, pathname]);

  return { hasPreviousPath };
}
